import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
  initBranchListInfo,

  requestBranchDetailFail,
  requestBranchDetailStart,
  requestBranchDetailSuccess,

  searchBranchListStart,
  searchBranchListSuccess,
  searchBranchListFail,

  requestBranchListStart,
  requestBranchListSuccess,
  requestBranchListFail,

  requestBranchCateFail,
  requestBranchCateStart,
  requestBranchCateSuccess,

  requestListCateBranchStart,
  requestListCateBranchSuccess,
  requestListCateBranchFail,

  addBranchCateStart,
  addBranchCateSuccess,
  addBranchCateFail,

  deleteBranchCateFail,
  deleteBranchCateStart,
  deleteBranchCateSuccess,

  addMapCateBranchFail,
  addMapCateBranchStart,
  addMapCateBranchSuccess,

  deleteMapCateBranchFail,
  deleteMapCateBranchStart,
  deleteMapCateBranchSuccess,

  mapProductBranchDetailFail,
  mapProductBranchDetailStart,
  mapProductBranchDetailSuccess,

  mapProductBranchFail,
  mapProductBranchSuccess,
  mapProductBranchStart,

  mapProductBranchListFail,
  mapProductBranchListStart,
  mapProductBranchListSuccess,

  importProductBranchFail,
  importProductBranchSuccess,
  importProductBranchStart,

  requestImportProductBranchFail,
  requestImportProductBranchSuccess,
  requestImportProductBranchStart,

  requestListBranchProductStart,
  requestListBranchProductSuccess,
  requestListBranchProductFail,

  requestListBranchFilterFail,
  requestListBranchFilterStart,
  requestListBranchFilterSuccess,

  requestBranchListHierarchyStart,
  requestBranchListHierarchySuccess,
  requestBranchListHierarchyFail,

  requestBranchTypeListStart,
  requestBranchTypeListSuccess,
  requestBranchTypeListFail,

  requestBranchTagListStart,
  requestBranchTagListSuccess,
  requestBranchTagListFail,

  requestBranchCategoryListStart,
  requestBranchCategoryListSuccess,
  requestBranchCategoryListFail,

  requestBranchActiveListStart,
  requestBranchActiveListSuccess,
  requestBranchActiveListFail,

  requestBranchPageListStart,
  requestBranchPageListSuccess,
  requestBranchPageListFail,

  requestPageAddBranchStart,
  requestPageAddBranchSuccess,
  requestPageAddBranchFail,

  requestPageDeleteBranchStart,
  requestPageDeleteBranchSuccess,
  requestPageDeleteBranchFail,

} from '../actions/branch';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET, method_DELETE, method_PUT, method_IMPORT } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint
const cloud_url = CONFIG.jnzAuthConfig.authEndpoint

export function* requestBranchDetail({ payload }) {

  /*console.log('[sages] requestBranchDetail : ', payload);*/

  const apiURL = `${cloud_url}/company/v1/branch/${payload?.branch_code}`;

  //====================================================================================================================

  try {
    const data = yield method_GET(
      {
        url: apiURL,
        params: payload?.params
      }
    );

    /*console.log("[API] POST : ",);*/

    yield put(requestBranchDetailSuccess(data));

  } catch (error) {
    yield put(requestBranchDetailFail(error));
  }

  //====================================================================================================================

}

export function* searchBranchList({ payload }) {

  /*console.log('[sages] searchBranchList : ', payload);*/

  const apiURL = `${cloud_url}/company/v1/branch/search`;

  //====================================================================================================================

  try {
    const data = yield method_GET(
      {
        url: apiURL,
        params: payload?.data
      }
    );

    /*console.log("[API] POST : ",);*/

    yield put(searchBranchListSuccess(data));

  } catch (error) {
    yield put(searchBranchListFail(error));
  }

  //====================================================================================================================

}

export function* requestBranchList(data) {

  /*console.log('[sages] requestBranchList : ', data);*/

  const apiURL = `${url}/backend/v1/branch/external`;

  //====================================================================================================================

  try {
    const data = yield method_GET({ url: apiURL });

    /*console.log("[API] GET : ",);*/

    yield put(requestBranchListSuccess(data));

  } catch (error) {
    yield put(requestBranchListFail(error));
  }

  //====================================================================================================================

}


export function* requestBranchCate({ payload }) {

  /*console.log('[sages] requestBranchCate : ', payload);*/

  const apiURL = `${url}/backend/v1/category-display/${payload.uuid}/branch`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: {
        "pagination[page]": payload.page === 0 ? 1 : payload.page,
        "pagination[limit]": payload.limit,
        "filter[branch]": payload.branch
      },
    });

    /*console.log("[API] GET : ", data);*/

    yield put(requestBranchCateSuccess(data));

  } catch (error) {
    yield put(requestBranchCateFail(error));
  }

  //====================================================================================================================
}

export function* requestListCateBranch({ payload }) {

  /*console.log('[sages] requestListCateBranch : ', payload);*/

  const apiURL = `${url}/backend/v1/category-display/branch`;

  //====================================================================================================================

  try {
    const data = yield method_POST({
      url: apiURL,
      data: payload.data,
      params: {
        "pagination[page]": payload.page === 0 ? 1 : payload.page,
        "pagination[limit]": payload.limit,
        "sort[field]": payload.field,
        "sort[order]": payload.order,
        "filter[q]": payload.q
      }
    });

    /*console.log("[API] GET : ", data);*/

    yield put(requestListCateBranchSuccess(data));

  } catch (error) {
    yield put(requestListCateBranchFail(error));
  }

  //====================================================================================================================
}


export function* addBranchCate({ payload }) {

  console.log('[sages] addBranchCate : ', payload);

  const apiURL = `${url}/backend/v1/category-display/${payload.uuid}/branch`;

  //====================================================================================================================

  try {
    const data = yield method_POST(
      {
        url: apiURL,
        data: payload.data
      }
    );

    /*console.log("[API] POST : ", data);*/

    yield put(addBranchCateSuccess(data));

  } catch (error) {
    yield put(addBranchCateFail(error));
  }

  //====================================================================================================================
}

export function* deleteBranchCate({ payload }) {
  /*console.log('[sages] deleteBranchCate : ', payload);*/
  // const apiURL = `${url}/backend/v1/category-display/${payload.uuid}/branch`;
  const apiURL = `${url}/backend/v1/category-display/branch/map`;

  //====================================================================================================================

  try {
    const data = yield method_DELETE(
      {
        url: apiURL,
        data: payload.data
      }
    );

    /*console.log("[API] DELETE : ", data);*/

    yield put(deleteBranchCateSuccess(data));

  } catch (error) {
    yield put(deleteBranchCateFail(error));
  }

  //====================================================================================================================
}

export function* addMapCateBranch({ payload }) {
  /*console.log('[sages] addMapCateBranch : ', payload);*/
  const apiURL = `${url}/backend/v1/category-display/branch/map`;

  //====================================================================================================================

  try {
    const data = yield method_POST(
      {
        url: apiURL,
        data: payload.data
      }
    );

    /*console.log("[API] POST : ", data);*/

    yield put(addMapCateBranchSuccess(data));

  } catch (error) {
    yield put(addMapCateBranchFail(error));
  }

  //====================================================================================================================
}


export function* deleteMapCateBranch({ payload }) {
  /*console.log('[sages] deleteMapCateBranch : ', payload);*/
  const apiURL = `${url}/backend/v1/category-display/branch/map`;

  //====================================================================================================================

  try {
    const data = yield method_DELETE(
      {
        url: apiURL,
        data: payload.data
      }
    );

    /*console.log("[API] DELETE : ", data);*/

    yield put(deleteMapCateBranchSuccess(data));

  } catch (error) {
    yield put(deleteMapCateBranchFail(error));
  }

  //====================================================================================================================
}

export function* mapProductBranch({ payload }) {
  /*console.log('[sages] mapProductBranch : ', payload);*/
  const apiURL = `${url}/backend/v1/product/branch/map`;

  //====================================================================================================================

  try {
    const data = yield method_POST(
      {
        url: apiURL,
        data: payload.data
      }
    );

    /*console.log("[API] POST : ", data);*/

    yield put(mapProductBranchSuccess(data));

  } catch (error) {
    yield put(mapProductBranchFail(error));
  }

  //====================================================================================================================
}

export function* mapProductBranchList({ payload }) {

  /*console.log('[sages] mapProductBranchList : ', payload);*/

  const apiURL = `${url}/backend/v1/product/branch/${payload.branch_code}`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: {
        "pagination[page]": payload.page === 0 ? 1 : payload.page,
        "pagination[limit]": payload.limit,
        "sort[field]": payload.field,
        "sort[order]": payload.order,
        "filter[q]": payload.q,
        "filter[brand]": payload.brand,
        "filter[category_display]": payload.category_display,
        "filter[in_branch]": payload.in_branch === null ? false : payload.in_branch,
      }
    });

    /*console.log("[API] GET : ", data);*/

    yield put(mapProductBranchListSuccess(data));

  } catch (error) {
    yield put(mapProductBranchListFail(error));
  }

  //====================================================================================================================
}

export function* mapProductBranchDetail({ payload }) {

  /*console.log('[sages] mapProductBranchDetail : ', payload);*/

  const apiURL = `${url}/backend/v1/product/branch/${branch_code}/${product_uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: {
        "pagination[page]": payload.page === 0 ? 1 : payload.page,
        "pagination[limit]": payload.limit,
        "sort[field]": payload.field,
        "sort[order]": payload.order,
        "filter[q]": payload.q,
        "filter[brand]": payload.brand,
        "filter[category_display]": payload.category_display,
      }
    });

    /*console.log("[API] GET : ", data);*/

    yield put(mapProductBranchDetailSuccess(data));

  } catch (error) {
    yield put(mapProductBranchDetailFail(error));
  }

  //====================================================================================================================
}

export function* importProductBranch({ payload }) {
  /*console.log('[sages] importProductBranch : ', payload);*/
  const apiURL = `${url}/backend/v1/import/branch-product-bulk`;
  const formData = new FormData();
  formData.append('file', payload.file);
  //====================================================================================================================

  try {
    const data = yield method_IMPORT(
      {
        url: apiURL,
        data: formData
      }
    );

    /*console.log("[API] POST : ", data);*/

    yield put(importProductBranchSuccess(data));

  } catch (error) {
    yield put(importProductBranchFail(error));
  }

  //====================================================================================================================

}

export function* requestImportProductBranch({ payload }) {

  /*console.log('[sages] requestImportProductBranch : ', payload);*/

  const apiURL = `${url}/backend/v1/import/branch-product-bulk`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: {
        "pagination[page]": payload.page === 0 ? 1 : payload.page,
        "pagination[limit]": payload.limit,
        "sort[field]": payload.field,
        "sort[order]": payload.order,
      }
    });

    /*console.log("[API] GET : ", data);*/

    yield put(requestImportProductBranchSuccess(data));

  } catch (error) {
    yield put(requestImportProductBranchFail(error));
  }

  //====================================================================================================================

}

export function* requestListBranchProduct({ payload }) {

  /*console.log('[sages] requestListBranchProduct : ', payload);*/

  const apiURL = `${url}/backend/v1/product/${payload.uuid}/branch`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: {
        "pagination[page]": payload.page === 0 ? 1 : payload.page,
        "pagination[limit]": payload.limit,
        "filter[branch]": payload.branch,
      }
    });

    /*console.log("[API] GET : ", data);*/

    yield put(requestListBranchProductSuccess(data));

  } catch (error) {
    yield put(requestListBranchProductFail(error));
  }

  //====================================================================================================================
}

export function* requestListBranchFilter({ payload }) {

  /*console.log('[sages] requestListBranchFilter : ', payload);*/

  const apiURL = `${cloud_url}/company/v1/branch/filter/list`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: payload?.params
    });

    /*console.log("[API] GET : ", data);*/

    yield put(requestListBranchFilterSuccess(data));

  } catch (error) {
    yield put(requestListBranchFilterFail(error));
  }

  //====================================================================================================================
}


export function* requestBranchTypeList({ payload }) {

  console.log('[sages] requestBranchTypeList : ', payload);

  const apiURL = `${cloud_url}/company/v1/branch_type/list`;


  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: payload?.params
    });

    /*console.log("[API] GET : ", data);*/

    yield put(requestBranchTypeListSuccess(data));

  } catch (error) {
    yield put(requestBranchTypeListFail(error));
  }

  //====================================================================================================================
}


export function* requestListBranchHierarchy({ payload }) {

  console.log('[sages] requestListBranchHierarchy : ', payload);

  const apiURL = `${cloud_url}/company/v1/branch_hierarchy/list`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: payload?.params
    });

    // console.log("[API] GET : ", data);

    yield put(requestBranchListHierarchySuccess(data));

  } catch (error) {
    yield put(requestBranchListHierarchyFail(error));
  }

  //====================================================================================================================
}

export function* requestListBranchActiveList({ payload }) {

  console.log('[sages] requestListBranchActiveList : ', payload);

  const apiURL = `${cloud_url}/company/v1/branch/list/active`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: payload?.params
    });

    // console.log("[API] GET : ", data);

    yield put(requestBranchActiveListSuccess(data));

  } catch (error) {
    yield put(requestBranchActiveListFail(error));
  }

  //====================================================================================================================
}

export function* requestBranchTagList({ payload }) {

  console.log('[sages] requestBranchTagList : ', payload);

  const apiURL = `${cloud_url}/company/v1/branch_tag/list`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: payload?.params
    });

    // console.log("[API] GET : ", data);

    yield put(requestBranchTagListSuccess(data));

  } catch (error) {
    yield put(requestBranchTagListFail(error));
  }

  //====================================================================================================================
}

export function* requestBranchCategoryList({ payload }) {

  console.log('[sages] requestBranchCategoryList : ', payload);

  const apiURL = `${cloud_url}/company/v1/branch_category/list`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: payload?.params
    });

    // console.log("[API] GET : ", data);

    yield put(requestBranchCategoryListSuccess(data));

  } catch (error) {
    yield put(requestBranchCategoryListFail(error));
  }

  //====================================================================================================================
}

export function* requestBranchPageList({ payload }) {

  // console.log('[sages] requestBranchPageList : ', payload);

  const { uuid, page = 1, limit = 9999, field = 'branch_id', order = 'asc' } = payload || {};

  const apiURL = `${url}/backend/v2/cms/${uuid}/branch`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      params: {
        "pagination[page]": ((page === 0) ? 1 : page),
        "pagination[limit]": limit,
        "sort[field]": field,
        "sort[order]": order,
      }
    });

    // console.log("[API] GET : ", data);

    yield put(requestBranchPageListSuccess(data));

  } catch (error) {
    yield put(requestBranchPageListFail(error));
  }

  //====================================================================================================================
}

export function* requestPageAddBranch({ payload }) {

  console.log('[sages] requestPageAddBranch : ', payload);

  const { uuid } = payload || {};

  const apiURL = `${url}/backend/v2/cms/${uuid}/branch`;

  //====================================================================================================================

  try {
    const data = yield method_POST({
      url: apiURL,
      data: payload.data,
    });

    /*console.log("[API] GET : ", data);*/

    yield put(requestPageAddBranchSuccess(data));

  } catch (error) {
    yield put(requestPageAddBranchFail(error));
  }

  //====================================================================================================================
}

export function* requestPageDeleteBranch({ payload }) {

  console.log('[sages] requestPageDeleteBranch : ', payload);

  const { uuid } = payload || {};

  const apiURL = `${url}/backend/v2/cms/${uuid}/branch`;

  //====================================================================================================================

  try {
    const data = yield method_DELETE(
      {
        url: apiURL,
        data: payload.data
      }
    );

    /*console.log("[API] DELETE : ", data);*/

    yield put(requestPageDeleteBranchSuccess(data));

  } catch (error) {
    yield put(requestPageDeleteBranchFail(error));
  }

  //====================================================================================================================
}

export function* requestPagePatchBranch({ payload }) {

  console.log('[sages] requestPageAddBranch : ', payload);

  const { uuid } = payload || {};

  const apiURL = `${url}/backend/v2/cms/${uuid}/branch`;

  //====================================================================================================================

  try {
    const data = yield method_PUT({
      url: apiURL,
      data: payload.data,
    });

    /*console.log("[API] GET : ", data);*/

    yield put(requestPageAddBranchSuccess(data));

  } catch (error) {
    yield put(requestPageAddBranchFail(error));
  }

  //====================================================================================================================
}


export function* watchBranch() {

  /*console.log('[sages] watchBranchList : ✅');*/

  yield all([
    takeLatest(requestBranchDetailStart, requestBranchDetail),
    takeLatest(searchBranchListStart, searchBranchList),
    takeLatest(requestBranchListStart, requestBranchList),
    takeLatest(requestBranchCateStart, requestBranchCate),
    takeLatest(requestListCateBranchStart, requestListCateBranch),
    takeLatest(addBranchCateStart, addBranchCate),
    takeLatest(deleteBranchCateStart, deleteBranchCate),
    takeLatest(addMapCateBranchStart, addMapCateBranch),
    takeLatest(deleteMapCateBranchStart, deleteMapCateBranch),
    takeLatest(mapProductBranchStart, mapProductBranch),
    takeLatest(mapProductBranchListStart, mapProductBranchList),
    takeLatest(mapProductBranchDetailStart, mapProductBranchDetail),
    takeLatest(importProductBranchStart, importProductBranch),
    takeLatest(requestImportProductBranchStart, requestImportProductBranch),
    takeLatest(requestListBranchProductStart, requestListBranchProduct),
    takeLatest(requestListBranchFilterStart, requestListBranchFilter),
    takeLatest(requestBranchListHierarchyStart, requestListBranchHierarchy),
    takeLatest(requestBranchTypeListStart, requestBranchTypeList),
    takeLatest(requestBranchTagListStart, requestBranchTagList),
    takeLatest(requestBranchCategoryListStart, requestBranchCategoryList),
    takeLatest(requestBranchActiveListStart, requestListBranchActiveList),
    takeLatest(requestBranchPageListStart, requestBranchPageList),
    // takeLatest(requestPageAddBranchStart, requestPageAddBranch),
    takeLatest(requestPageAddBranchStart, requestPagePatchBranch),
    takeLatest(requestPageDeleteBranchStart, requestPageDeleteBranch),
  ])
}



